import { Link } from '@tanstack/react-router';
import { Wallet } from 'lucide-react';
import { ModeToggle } from './mode-toggle';
import { MobileSidebar } from './sidebar';
import UserMenu from './user-menu';

export default function Header() {
  return (
    <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container mx-auto flex h-16 max-w-screen-2xl items-center px-4">
        {/* Mobile Sidebar Trigger */}
        <MobileSidebar />

        {/* Logo */}
        <Link className="mr-6 flex items-center gap-3" to="/">
          <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary text-primary-foreground">
            <Wallet className="h-4 w-4" />
          </div>
          <span className="font-bold text-foreground text-xl">
            Control Money
          </span>
        </Link>

        {/* Spacer */}
        <div className="flex-1" />

        {/* Actions */}
        <div className="flex items-center gap-3">
          <ModeToggle />
          <UserMenu />
        </div>
      </div>
    </header>
  );
}
